import React from "react"
import "./question.scss"
import { useFormik } from "formik"
import { encode, emailRegexp } from "../../utilities/functions"
import Telecom from "../svg/telecom"
import Arrow from "../arrow/arrow"
import PropTypes from "prop-types"

function validate (values) {
  const errors = {};
  const requiredMessage = 'Поле не может быть пустым';
  if (!values.qname) {
    errors.qname = requiredMessage;
  }

  if (!values.qemail) {
    errors.qemail = requiredMessage;

  } else if (!emailRegexp.test(values.qemail)) {
    errors.qemail = 'Неверный e-mail адрес';

  }

  if (!values.qtext) {
    errors.qtext = requiredMessage;
  } else if (values.qtext.length < 5) {
    errors.qtext = 'Сообщение должно быть не короче 5 символов';
  }

  return errors;
}

const Question = ({ closeModal }) => {
  const handleSubmit = values => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "question", ...values })
    })
      .then(() => {
        closeModal()
        alert("Сообщение отправлено!")
      })
      .catch(error => alert(error))
  }
  const formik = useFormik({
    initialValues: {
      qname: "",
      qemail: "",
      qtext: ""
    },
    validate,
    onSubmit: handleSubmit
  })
  return (
    <div className="question">
      <div className="question__img">
        <Telecom />
      </div>
      <form
        onSubmit={formik.handleSubmit}
        name="question"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input
          type="hidden"
          name="form-name"
          value="question"
        />
        <div className="question__warning first--warning">
          {
            formik.touched.qname && formik.errors.qname
              ? formik.errors.qname
              : null
          }
        </div>
        <input
          type="text"
          id="qname"
          name="qname"
          value={formik.values.qname}
          placeholder="Имя"
          {...formik.getFieldProps("qname")}
        />
        <div className="question__warning">
          {
            formik.touched.qemail && formik.errors.qemail
              ? formik.errors.qemail
              : null
          }
        </div>
        <input
          type="email"
          id="qemail"
          name="qemail"
          title="Please enter your e-mail"
          value={formik.values.qemail}
          placeholder="e-mail"
          {...formik.getFieldProps("qemail")}
          required
        />
        <div className="question__warning">
          {
            formik.touched.qtext && formik.errors.qtext
              ? formik.errors.qtext
              : null
          }
        </div>
        <textarea
          id="qtext"
          name="qtext"
          value={formik.values.qtext}
          placeholder="Ваш текст"
          {...formik.getFieldProps("qtext")}
        />
        <button
          type="submit"
          className="button submit"
        >
          <h4>ОТПРАВИТЬ</h4>
          <Arrow direction="right" />
        </button>
      </form>
    </div>
  )
}

Question.propTypes = {
  closeModal: PropTypes.func
}

Question.defaultProps = {
  closeModal: () => {
    alert(`Oops, something went wrong! Please reload the page to close modal window`);
    console.error("No closeModal function provided");
  }
}
export default Question
